module.exports = __webpack_public_path__ + "img/bank-card.7eb49db0.png";